function Loader() {
  return (
    <div className="animated yt-loader"></div>
  );
}
export default Loader;
